import { DataModel } from "common/models/utility-models/base-model"
import { UploadFileModel } from "../custom-model/uploadfile.model"
import { TravelReimbursementListingModel } from "../travel-reimbursement/travel-reimbursement-grid.model"
import { studentAssignmenListingtModel } from "./student-assignment-model"
import { studentInternshipDataModel } from "./student-internship-data-model"

export class StudentDetailsModel extends DataModel {
    student_id: any = '';
    first_name: string = ''
    last_name: string = ''
    father_name: string = ''
    mother_name: string = ''
    mobile_number: string = ''
    parentMobileNumber: string = ''
    email: string = ''
    gender: string = ''
    address: string = ''
    age: string = ''
    region_id: string = ''
    state_id: string = ''
    state_name: string = ''
    district: string = ''
    name_of_college: string = ''
    college_address: string = ''
    unique_batch_id: string = ''
    branch_id: string = ''
    branch_name: string = ''
    batch_id: number = 0
    batch_number: string = ''
    remarks: string = '';
    mentor_name: any;
    mentorId: string = '';
    mentor_email: string = ''
    mentor_mobile: string = ''
    summer_vacation_start_date: any = ''
    summer_vacation_end_date: any = ''
    winter_vacation_start_date: any = ''
    winter_vacation_end_date: any = ''
    first_year_score: any = ''
    second_year_score: any = ''
    third_year_score: any = ''
    fourth_year_score: any = ''
    first_year2_score: any = ''
    second_year2_score: any = ''
    third_year2_score: any = ''
    fourth_year2_score: any = ''
    ktsem1:number = 0
    ktsem2:number = 0
    ktsem3:number = 0
    ktsem4:number = 0
    ktsem5:number = 0
    ktsem6:number = 0
    ktsem7:number = 0
    ktsem8:number = 0
    placement_company_name: string = ''
    placement_company_location: string = ''
    placement_company_designation: string = ''
    placement_company_package_id: string = ''
    placement_company_package: string = ''
    placement_company_type: string = ''
    first_year_credit: any = ''
    second_year_credit: any = ''
    third_year_credit: any = ''
    fourth_year_credit: any = ''
    year: number = 1;
    batchs: any = []
    application_form: any = '';
    conduct_certificate: any = '';
    enrollment_letter: any = '';
    fee_structure: any = '';
    fee_receipt_yearly: any = '';
    resume: any = '';
    application2: any = '';
    conductCertificate2: any = '';
    enrollment2: any = '';
    feeStructure2: any = '';
    feeReceipt2: any = '';
    resume2: any = '';
    application3: any = '';
    conductCertificate3: any = '';
    enrollment3: any = '';
    feeStructure3: any = '';
    feeReceipt3: any = '';
    resume3: any = '';
    application4: any = '';
    conductCertificate4: any = '';
    enrollment4: any = '';
    feeStructure4: any = '';
    feeReceipt4: any = '';
    resume4: any = '';
    semester: number = 1;
    resultSem1: any = '';
    feeReceiptSem1: any = '';
    resultSem2: any = '';
    feeReceiptSem2: any = '';
    resultSem3: any = '';
    feeReceiptSem3: any = '';
    resultSem4: any = '';
    feeReceiptSem4: any = '';
    resultSem5: any = '';
    feeReceiptSem5: any = '';
    resultSem6: any = '';
    feeReceiptSem6: any = '';
    resultSem7: any = '';
    feeReceiptSem7: any = '';
    resultSem8: any = '';
    feeReceiptSem8: any = '';
    studentAchievementDetails: any = [];
    profile_pic_path: any ;
    studentDetailsGridData:any=[];
    assignment_detail: studentAssignmenListingtModel;    
    details:studentInternshipDataModel[] = [];
    studentDocumentDetails: UploadFileModel | any = [];
    studentAnnualData:UploadFileModel | any = []
    studentSemiAnnualData: UploadFileModel | any = [];
    studentDocumentDetailsList: UploadFileModel | any = [];
    apiStudentDocumentDetailsList: any = [];
    travel_reimbursement: TravelReimbursementListingModel;
    batch_duration_start: any = '';
    travelReimbursementData: any = [];
    status: string = "";
    isEditable:any=[];
    status_reason:string = "";
    status_remark:string = "";
    mentoringDocumentData: any = [];
    studentFeedback: any = [];
    uploadedFileName: any = '';
    user_id:number=0
    district_id: number = 0
    other: any;
    isInternshipCertyVerified: any;
    internshipCertificateFilename: any;
    title: any = '';
    fileOriginalName: any = '';
    fileName: any = '';
}

export class studentDetails {
    first_name: string = ''
    last_name: string = ''
    father_name: string = ''
    mother_name: string = ''
    mobile_number: '';
    parentMobileNumber: string = ''
    email: '';
    batch_number: string = ''
    address: '';
    gender: '';
    age: string = ''
    region_id: string = ''
    state_name: '';
    first_year_score: '';
    second_year_score: '';
    third_year_score: '';
    fourth_year_score: '';
    first_year2_score: '';
    second_year2_score: '';
    third_year2_score: '';
    fourth_year2_score: '';
    ktsem1: number = 0
    ktsem2: number = 0
    ktsem3: number = 0
    ktsem4: number = 0
    ktsem5: number = 0
    ktsem6: number = 0
    ktsem7: number = 0
    ktsem8: number = 0
    student_id: '';
    placement_company_package_id: '';
    placement_company_name: '';
    placement_company_location: '';
    placement_company_designation: '';
    first_year_credit:any = ''
    second_year_credit:any = ''
    third_year_credit:any = ''
    fourth_year_credit:any = ''
    date_of_birth:any = ''
    status_remark:any = ''
    other:any;
    isInternshipCertyVerified: any;
  }

  export class mentorLogs extends DataModel {
    override id: any = '';
  }